import { defineComponent, ref } from 'vue'
import ProgressBar from '../progress-bar'
import { useGlobalProgress } from './hook'
import { useInterpolation } from '@/utils/animation/useInterpolation'
import { useEffect } from '@/utils/reactive/useEffect'

const GlobalProgress = defineComponent({
  setup() {
    const handle = useGlobalProgress()

    const interp = useInterpolation({
      initial: 0,
      duration: 1.0
    })

    const flip = ref<boolean>(false)

    useEffect(() => {
      if (handle.running.value && !flip.value) {
        interp.runTo(1.0)
        flip.value = true
      } else if (flip.value) {
        interp.runTo(0.0).then(() => {
          handle.clear()
        })
        flip.value = false
      }
    }, [handle.running])

    return () => {
      return (
        <div
          style={{
            width: '100%',
            position: 'fixed',
            bottom: 0,
            left: 0,
            pointerEvents: 'none',
            opacity: `${interp.state.value * 100}%`,
            zIndex: 999,
            ...(interp.state.value <= 0.000001 && handle.running.value === false
              ? {
                  display: 'none'
                }
              : {})
          }}
        >
          <ProgressBar square size="xs" value={handle.progress.value * 100} />
        </div>
      )
    }
  }
})

export default GlobalProgress
